module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'jp'],
  prerender: true,
  wordpressAPIUrl: `enera.ca/wordpress/wp-json/wp/v2`
};
